import {
    createContext,
    useContext,
    useState,
    useEffect,
    ReactNode,
} from "react";
import TwitchLoginModal from "../components/TwitchLoginModal";

const UserContext = createContext<UserProviderType | null>(null);
const COIN_REFRESH_TIME = 10 * 1000;

export const useUser = () => {
    const ctx = useContext(UserContext);
    if (!ctx) throw new Error("useUser must be used inside of UserProvider");
    return ctx;
};

export type TwitchUser = {
    displayName: string; //"MythicAbyss";
    id: string; //"524796577";
    isFollowing: boolean; //false;
    isSubscriber: boolean; //true;
    isModerator: boolean; //false;
    login: string; //"mythicabyss";
    profileImage: string; //"https://static-cdn.jtvnw.net/jtv_user_pictures/308bcab9-3d8b-494c-8855-02fcdacab8e7-profile_image-300x300.png";
};

export type UserProviderType = {
    user: TwitchUser;
    logout: () => void;

    coins: number;
    setCoins: React.Dispatch<React.SetStateAction<number>>;
};

interface Props {
    children: ReactNode;
}

export const UserProvider = ({ children }: Props) => {
    const [user, setUser] = useState<TwitchUser | null>(null);
    const [coins, setCoins] = useState(0);

    useEffect(() => {
        // Get the user info from Twitch
        fetch(`${import.meta.env.VITE_SERVER_URL || ""}/api/auth/me`, {
            credentials: "include",
        })
            .then((res) => {
                return res.text();
            })
            .then((text) => {
                console.log(text);
                if (text) {
                    setUser(JSON.parse(text).user);
                }
            })
            .catch((err) => console.error("Auth check failed:", err));
    }, []);

    useEffect(() => {
        if (!user) return;
        const fetchCoins = () => {
            // Get the user's coins
            fetch(`${import.meta.env.VITE_SERVER_URL || ""}/api/coins/get`, {
                credentials: "include",
            })
                .then((res) => {
                    return res.json();
                })
                .then((json) => {
                    if (!json.loggedIn && coins) {
                        setUser(null);
                        setCoins(0);
                    }
                    if (json && json.coins !== coins) {
                        if (coins === json.coins) return;

                        console.log("Coin update:", json.coins);
                        setCoins(json.coins);
                    }
                });
        };

        fetchCoins();

        const interval = setInterval(fetchCoins, COIN_REFRESH_TIME);
        return () => clearInterval(interval);
    }, [user]);

    const value = {
        user,
        setUser,
        coins,
        setCoins,
    };

    return (
        <UserContext.Provider
            value={{
                user: user!,
                coins,
                setCoins,
                logout: () => {
                    setUser(null);
                },
            }}
        >
            {!user && <TwitchLoginModal />}
            {user && children}
        </UserContext.Provider>
    );
};
